import { getTableMetaHelper, ProgressBar } from '@round/ui-kit';
import { CampaignsTableMeta } from 'Modules/Plans/Campaigns/types';
import { CellContext } from '@tanstack/react-table';
import { CampaignTableRow } from '../types';
import Skeleton from 'react-loading-skeleton';
import styles from '../PublicReportCampaignTable.module.css';
import { toDecimalPoint } from '@round/utils';

const getTableMeta = getTableMetaHelper<CampaignsTableMeta>();

type Props = CellContext<CampaignTableRow, any>;

const ProgressCell = ({ row: { original }, table }: Props) => {
    const { isLoading, getIsCampaignStatsLoading } = getTableMeta(table);
    const { stats } = original;

    if (isLoading || getIsCampaignStatsLoading?.(original)) {
        return <Skeleton />;
    }

    if (!stats) {
        return '-';
    }

    const progressPercentage = stats.progress_percentage;

    return (
        <div className={styles.progressContainer}>
            <p className={styles.progressPercentage}>
                {typeof progressPercentage === 'number' ? `${toDecimalPoint(progressPercentage, 2)}%` : '-'}
            </p>
            {typeof progressPercentage === 'number' && (
                <ProgressBar
                    progress={progressPercentage}
                    trackClassName={styles.progressTrack}
                    barClassName={styles.progressBar}
                />
            )}
        </div>
    );
};

export default ProgressCell;
